// extracted by mini-css-extract-plugin
module.exports = {"icon-play":"styles_icon-play__oQU3H"};